import Swiper from "swiper";
import "swiper/swiper.scss";

export function run(options) {
  return new Swiper(".swiper", {
    lazy: true,
    loop: true,
    slidesPerView: "auto",
    centeredSlides: true,
    centeredSlidesBounds: true,
    ...options,
  });
}
